module.exports = __webpack_public_path__ + "img/banner02.6a23fd1b.jpg";